import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
	FreudButtonModule,
	FreudCardModule,
	FreudCheckboxModule,
	FreudInputTextModule,
	FreudPaginatorModule,
	FreudSelectModule,
} from '@freud-ds/web-components';
import { TranslateModule } from '@ngx-translate/core';

import { AppointmentSidebarModule } from './../../../appointments/components/appointment-sidebar/appointment-sidebar.module';
import { ContactBulkActionsModule } from '../contact-bulk-actions/contact-bulk-actions.module';
import { ContactsAnalyticsModule } from '../contacts-analytics/contacts-analytics.module';
import { ContactsInactivesBannerModule } from '../contacts-inactives-banner/contacts-inactives-banner.module';
import { ContactsTableFiltersSidebarModule } from '../contacts-table-filters-sidebar/contacts-table-filters-sidebar.module';
import { ContactsTableModule } from '../contacts-table/contacts-table.module';
import { ContactsListPageComponent } from './contacts-list-page.component';

@NgModule({
	declarations: [ContactsListPageComponent],
	imports: [
		CommonModule,
		TranslateModule,
		ContactsTableModule,
		FreudCardModule,
		FreudInputTextModule,
		FormsModule,
		FreudButtonModule,
		FreudSelectModule,
		FreudPaginatorModule,
		AppointmentSidebarModule,
		ContactsAnalyticsModule,
		ContactsInactivesBannerModule,
		FreudCheckboxModule,
		ContactBulkActionsModule,
		ContactsTableFiltersSidebarModule,
	],
	exports: [ContactsListPageComponent],
	providers: [],
})
export class ContactsListPageModule {}
